<!--https://medium.com/@claudiaconceic/infinite-plain-javascript-slider-click-and-touch-events-540c8bd174f2-->
<!--https://codepen.io/cconceicao/pen/PBQawy-->
<template>
    <div id="slider" class="slider" >
        <div class="wrapper">
            <div id="slides" class="slides">
                <div v-for="(item, i) in banners" :key="i" class="slide">
                    <img :src="item.imPath" class="slideItem_d"/>
                    <img :src="item.imPath_m" class="slideItem_m"/>
                </div>
            </div>
        </div>
        <a id="prev" class="control prev"></a>
        <a id="next" class="control next"></a>
    </div>
</template>

<script>
import { commonMixin } from '../../scripts/commonMixin'

export default {
    mixins: [commonMixin],
    data () {
        return {
            posY1: 0,
            posX1: 0,
            posX2: 0,
            posInitial: 0,
            posFinal: 0,
            threshold: 100,
            index: 0,
            allowShift: true,
            slideSize: {},
            slidesLength: 0,
            items: {},
            slidesAutoTime: 5000,
            waitingForShift: false,
            banners: [
                {
                    imPath: '/static/imgs/banners/banner_desk_ouro.jpg',
                    imPath_m: '/static/imgs/banners/banner_mob_ouro.jpg',
                    href: ''
                },
                {
                    imPath: '/static/imgs/banners/banner_desk_prata.jpg',
                    imPath_m: '/static/imgs/banners/banner_mob_prata.jpg',
                    href: ''
                },
                {
                    imPath: '/static/imgs/banners/banner_desk_relogio.jpg',
                    imPath_m: '/static/imgs/banners/banner_mob_relogio.jpg',
                    href: ''
                }
            ]
        }
    },
    methods: {
        slide (wrapper, items, prev, next) {
            var slides = items.getElementsByClassName('slide')
            this.slidesLength = slides.length
            var firstSlide = slides[0]
            var cloneFirst = firstSlide.cloneNode(true)
            var lastSlide = slides[this.slidesLength - 1]
            var cloneLast = lastSlide.cloneNode(true)
            var vm = this

            this.items = items

            this.slideSize = items.getElementsByClassName('slide')[0].offsetWidth

            // Clone first and last slide
            items.appendChild(cloneFirst)
            items.insertBefore(cloneLast, firstSlide)
            wrapper.classList.add('loaded')

            // Mouse events
            items.onmousedown = this.dragStart

            // Touch events
            if (!this.isMobile()) {
                items.addEventListener('touchstart', this.dragStart)
                items.addEventListener('touchend', this.dragEnd)
                items.addEventListener('touchmove', this.dragAction)
            }

            // Click events
            prev.addEventListener('click', function () {
                vm.shiftSlide(-1)
            })
            next.addEventListener('click', function () {
                vm.shiftSlide(1)
            })

            // vm.shiftSlide(1)
            this.posInitial = this.items.offsetLeft
            this.index = 1
            this.items.style.left = (this.posInitial - this.slideSize) + 'px'

            // Transition events
            items.addEventListener('transitionend', this.checkIndex)
        },

        dragStart (e) {
            e = e || window.event
            e.preventDefault()
            this.posInitial = this.items.offsetLeft

            if (e.type === 'touchstart') {
                this.posY1 = e.touches[0].clientY
                this.posX1 = e.touches[0].clientX
            } else {
                this.posX1 = e.clientX
                document.onmouseup = this.dragEnd
                document.onmousemove = this.dragAction
            }
        },

        dragAction (e) {
            e = e || window.event

            if (e.type === 'touchmove') {
                this.posX2 = this.posX1 - e.touches[0].clientX
                this.posX1 = e.touches[0].clientX
                // se tiver um diff grande no Y
                // if (this.posY1 - e.touches[0].clientY > 100) {
                //     return
                // }
            } else {
                this.posX2 = this.posX1 - e.clientX
                this.posX1 = e.clientX
            }
            this.items.style.left = (this.items.offsetLeft - this.posX2) + 'px'
        },

        dragEnd (e) {
            this.posFinal = this.items.offsetLeft
            if (this.posFinal - this.posInitial < -this.threshold) {
                this.shiftSlide(1, 'drag')
            } else if (this.posFinal - this.posInitial > this.threshold) {
                this.shiftSlide(-1, 'drag')
            } else {
                this.items.style.left = (this.posInitial) + 'px'
            }

            document.onmouseup = null
            document.onmousemove = null
        },

        shiftSlide (dir, action) {
            this.items.classList.add('shifting')

            if (this.allowShift) {
                if (action === undefined) {
                    this.posInitial = this.items.offsetLeft
                }

                if (dir === 1) {
                    this.items.style.left = (this.posInitial - this.slideSize) + 'px'
                    this.index++
                } else if (dir === -1) {
                    this.items.style.left = (this.posInitial + this.slideSize) + 'px'
                    this.index--
                }
            }

            this.allowShift = false

            if (action === undefined && !this.waitingForShift) {
                var vm = this
                vm.waitingForShift = true
                setTimeout(function () {
                    vm.shiftSlide(1)
                    vm.waitingForShift = false
                }, vm.slidesAutoTime)
            }
        },

        checkIndex () {
            this.items.classList.remove('shifting')

            if (this.index === -1) {
                this.items.style.left = -(this.slidesLength * this.slideSize) + 'px'
                this.index = this.slidesLength - 1
            }

            if (this.index === this.slidesLength) {
                this.items.style.left = -(1 * this.slideSize) + 'px'
                this.index = 0
            }

            this.allowShift = true
        }
    },
    mounted () {
        console.log('Slider::mounted')

        this.slider = document.getElementById('slider')
        this.sliderItems = document.getElementById('slides')
        this.prev = document.getElementById('prev')
        this.next = document.getElementById('next')

        this.slide(this.slider, this.sliderItems, this.prev, this.next)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    * {
        /*box-sizing: border-box;*/
        /*--slider-width: 100vw;*/
        --slider-width: 100vw;
        --slider-height: 50vh;
    }

    body {
        height: 100%;
        background-color: #7656d6;
        color: #333;
        text-align: center;
        letter-spacing: 0.15em;
        font-size: 22px;
    }

    .slider {
        position: relative;
        width: var(--slider-width);
        height: var(--slider-height);
        /*box-shadow: 3px 3px 10px rgba(0,0,0,.2);*/
    }

    .wrapper {
        position: relative;
        overflow: hidden;
        width: var(--slider-width);
        height: var(--slider-height);
        /*z-index: 1;*/
    }

    .slides {
        display: flex;
        position: relative;
        top: 0;
        left: var(--slider-width);
        width: calc(var(--slider-width) * 10);
    }

    .slides.shifting {
        transition: left .5s linear;
    }

    .slide {
        width: var(--slider-width);
        height: var(--slider-height);
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        transition: all 1s;
        position: relative;
        /*background: #FFCF47;*/
        background-color: white;
        border-radius: 2px;
    }

    .slideItem_d, .slideItem_m {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .slideItem_m {
        display: none;
    }

    /*.slider:nth-child(0) { background-color: green; }*/
    /*.slider:nth-child(1) { background-color: red; }*/
    /*.slider:nth-child(2) { background-color: orange; }*/

    /*.slider.loaded,*/
    /*.slide:nth-child(2),*/
    /*.slide:nth-child(7) { background: #FFCF47 }*/
    /*.slide:nth-child(1),*/
    /*.slide:nth-child(6) { background: #7ADCEF }*/
    /*.slide:nth-child(3) { background: #3CFF96 }*/
    /*.slide:nth-child(4) { background: #a78df5 }*/
    /*.slide:nth-child(5) { background: #ff8686 }*/

    .control {
        position: absolute;
        top: 50%;
        width: 50px;
        height: 50px;
        background: #fff;
        border-radius: 50px;
        margin-top: -20px;
        box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);
        /*z-index: 2;*/
    }

    .prev,
    .next {
        background-size: 22px;
        background-position: center;
        background-repeat: no-repeat;
        /*background-color: red;*/
        cursor: pointer;
    }

    .prev {
        background-image: url('/static/imgs/ics/ic_right-128.png');
        left: -20px;
    }

    .next {
        background-image: url('/static/imgs/ics/ic_left-128.png');
        right: -20px;
    }

    .prev:active,
    .next:active {
        transform: scale(.8);
    }

    @media screen and (max-width: 999px) {
        * {
            --slider-width: 100vw;
            --slider-height: 80vh;
        }
        .next, .prev {
            background-size: 4vw;
        }
        .prev {
            left: 0.5%;
        }
        .next {
            right: 0.5%;
        }
        .control {
            width: 7vw;
            height: 7vw;
        }
        .slideItem_d {
            display: none;
        }
        .slideItem_m {
            display: unset;
        }
    }
    @media screen and (min-width: 1000px) {
        * {
            --slider-width: 90vw;
        }
    }
    @media screen and (min-width: 1400px) {
        * {
            --slider-width: 80vw;
        }
    }
    @media screen and (min-width: 1600px) {
        * {
            --slider-width: 70vw;
        }
    }
    @media screen and (min-width: 1900px) {
        * {
            --slider-width: 65vw;
        }
    }
    @media screen and (min-width: 2200px) {
        * {
            --slider-width: 50vw;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/templates/Slider.vue